
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/daily-usage-idioms-and-phrases",
      function () {
        return require("private-next-pages/elearning/daily-usage-idioms-and-phrases.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/daily-usage-idioms-and-phrases"])
      });
    }
  